// The library's web setString fires navigator.clipboard.writeText without handling rejection,
// so a denied write (e.g. inside third-party in-app browsers) becomes an unhandled rejection.
// execCommand runs first because it only works synchronously inside the user gesture,
// which WebKit may no longer honor after awaiting a rejected writeText.
export async function copyText(text: string): Promise<boolean> {
  if (copyWithExecCommand(text)) return true
  if (!navigator.clipboard) return false

  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}

function copyWithExecCommand(text: string): boolean {
  const previouslyFocused = document.activeElement
  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0'
  document.body.appendChild(textarea)
  textarea.select()
  // iOS Safari doesn't select a readonly textarea's content with select() alone
  textarea.setSelectionRange(0, text.length)
  try {
    return document.execCommand('copy')
  } catch {
    return false
  } finally {
    document.body.removeChild(textarea)
    if (previouslyFocused instanceof HTMLElement) previouslyFocused.focus()
  }
}
